
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmSkeleton 
} from '@vime/core';

import { define } from '../lib';
  

const SkeletonInputs: string[] = [
  'effect',
  'ready',
];

const SkeletonMethods: string[] = [
  
];

const SkeletonOutputs: string[] = [
  
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface Skeleton extends Components.VmSkeleton {}

@ProxyCmp({
  inputs: SkeletonInputs,
  methods: SkeletonMethods,
})
@Component({
  selector: 'vm-skeleton',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: SkeletonInputs,
  outputs: SkeletonOutputs,
})
export class Skeleton {
  protected el: HTMLElement;

  

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-skeleton', VmSkeleton);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, [])
  }
}
  